import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function PublicRoute({ children }: { children: React.ReactNode }) {
  const { accessToken } = useAuth();

  if (accessToken) {
    return <Navigate to="/app" replace />;
  }

  return <>{children}</>;
}
